import React from "react";
import HeroSection from "./HeroSection";
import CustomButton from "../ui/Button";
import { useTranslation } from "react-i18next";

const Cases = () => {
  const { t,i18n } = useTranslation("cases"); // Hook to use translations
  const isRussian = i18n.language === "ru"; // Check if the language is Russian


  return (
    <div>
      <HeroSection />

      <div className="p-8 md:p-20 xl:p-[140px] space-y-8 container-class">
        <div>
          <h1 className="web-heading-section">{t("case_studies_title")}</h1>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
          {/* First Column */}
          <div className="col-span-1">
            <div className="case1bg h-full px-6 py-10 flex flex-col justify-end">
              <p className="text-[12px] font-normal leading-3 pb-[11px]">
                {t("craig_bator_case_title")}
              </p>
              <div className="max-w-[306px]">

                <h1 className="text-[24px] md:text-[28px] xl:text-[34px] font-medium leading-normal capitalize pb-2">
                  {t("proximity_detection_system_case")}
                </h1>
                <p className="text-[12px] font-normal leading-3">
                  {t("stay_informed_title")}
                </p>
              </div>
            </div>
          </div>

          {/* Second Column */}
          <div className="col-span-1">
            <div className="case2bg h-full px-6 py-10 flex flex-col justify-end">
              <p className="text-[12px] font-normal leading-3 pb-[11px]">
                {t("craig_bator_case_title")}
              </p>
              <h1 className="text-[24px] md:text-[28px] xl:text-[34px] font-medium leading-normal capitalize pb-2">
                {t("automation_for_increased_efficiency")}
              </h1>
              <p className="text-[12px] font-normal leading-3">
                {t("stay_informed_title")}
              </p>
            </div>
          </div>

          {/* Third and Fourth Columns Combined */}
          <div className="col-span-1 md:col-span-2 flex flex-col gap-4">
            <div className="case3bg h-full px-6 pb-10 pt-[120px] md:pt-[140px] xl:pt-[163px] flex flex-col justify-end">
              <p className="text-[12px] font-normal leading-3 pb-[11px]">
                {t("craig_bator_case_title")}
              </p>
              <h1 className="text-[24px] md:text-[28px] xl:text-[34px] font-medium leading-normal capitalize pb-2">
                {t("predictive_maintenance_minimize_downtime")}
              </h1>
            </div>

            <div className="case4bg h-full px-6 pb-10 pt-[120px] md:pt-[140px] xl:pt-[163px] flex flex-col justify-end">
              <p className="text-[12px] font-normal leading-3 pb-[11px]">
                Craig Bator - 27 Dec 2020{t("craig_bator_case_title")}
              </p>
              <h1 className="text-[24px] md:text-[28px] xl:text-[34px] font-medium leading-normal capitalize pb-2">
                {t("environmental_monitoring_for_compliance")}
              </h1>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
          <div className="col-span-1 md:col-span-2 flex flex-col gap-4">
            <div className="case3bg h-full px-6 pb-10 pt-[120px] md:pt-[140px] xl:pt-[163px] flex flex-col justify-end">
              <p className="text-[12px] font-normal leading-3 pb-[11px]">
                {t("craig_bator_case_title")}
              </p>
              <h1 className="text-[24px] md:text-[28px] xl:text-[34px] font-medium leading-normal capitalize pb-2">
                {t("predictive_maintenance_minimize_downtime")}
              </h1>
            </div>

            <div className="case4bg h-full px-6 pb-10 pt-[120px] md:pt-[140px] xl:pt-[163px] flex flex-col justify-end">
              <p className="text-[12px] font-normal leading-3 pb-[11px]">
                {t("craig_bator_case_title")}
              </p>
              <h1 className="text-[24px] md:text-[28px] xl:text-[34px] font-medium leading-normal capitalize pb-2">
                {t("environmental_monitoring_for_compliance")}
              </h1>
            </div>
          </div>

          <div className="col-span-1">
            <div className="case1bg h-full px-6 py-10 flex flex-col justify-end">
              <p className="text-[12px] font-normal leading-3 pb-[11px]">
                {t("craig_bator_case_title")}
              </p>
              <h1 className="text-[24px] md:text-[28px] xl:text-[34px] font-medium leading-normal capitalize pb-2">
                {t("proximity_detection_system_case")}
              </h1>
              <p className="text-[12px] font-normal leading-3">
                {t("stay_informed_title")}
              </p>
            </div>
          </div>

          <div className="col-span-1">
            <div className="case2bg h-full px-6 py-10 flex flex-col justify-end">
              <p className="text-[12px] font-normal leading-3 pb-[11px]">
                {t("craig_bator_case_title")}
              </p>
              <h1 className="text-[24px] md:text-[28px] xl:text-[34px] font-medium leading-normal capitalize pb-2">
                {t("automation_for_increased_efficiency")}
              </h1>
              <p className="text-[12px] font-normal leading-3">
                {t("stay_informed_title")}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="p-5 sm:p-[100px] flex flex-col justify-center items-center gap-5 text-center ellipsebg">

        <div className='max-w-[818px] flex flex-col justify-center items-center text-center gap-5'>
          <h1 className="web-heading-section px-12">
            {t("join_team")}
          </h1>
          <p className={`body-large-30 text-[#F0F0F0B2] ${isRussian ? 'lang-ru-contact-desc' : ''}`}>

            {t("join_team_description")}
          </p>
          <CustomButton>{t("send_resume")}</CustomButton>

          <h2 className="title-xl-2">{t("spontaneous_applications")}</h2>

          <p className={`body-large-30 text-[#F0F0F0B2] ${isRussian ? 'lang-ru-contact-desc' : ''}`}>

            {t("spontaneous_applications_description")}
          </p>

        </div>

      </div>
    </div>
  );
};

export default Cases;
